import { globalModel } from "../../global/GlobalModel";
import { SpaceMessageCenterApi } from "./SpaceMessageCenterApi";
import type { MessageConversationRow } from "./SpaceMessageCenterTypes";

const POLL_MS = 3000;

/** 消息 Tab 角标与会话列表轮询 */
export class SpaceMessageCenterPollModel {
  private spaceId = "";
  private pollTimer: ReturnType<typeof setInterval> | null = null;
  private polling = false;
  private onUpdate: ((list: MessageConversationRow[], totalUnread: number) => void) | null = null;

  reset() {
    this.stopPoll();
    this.spaceId = "";
    this.onUpdate = null;
  }

  startPoll(spaceId: string, onUpdate: (list: MessageConversationRow[], totalUnread: number) => void) {
    const sid = spaceId.trim();
    if (!sid || !globalModel.isLoggedIn) {
      this.reset();
      return;
    }
    this.onUpdate = onUpdate;
    if (this.spaceId === sid && this.pollTimer) {
      return;
    }
    this.stopPoll();
    this.spaceId = sid;
    void this.syncOnce();
    this.pollTimer = setInterval(() => {
      void this.syncOnce();
    }, POLL_MS);
  }

  stopPoll() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }

  async syncOnce() {
    if (!this.spaceId || !globalModel.isLoggedIn || this.polling || !this.onUpdate) {
      return;
    }
    this.polling = true;
    try {
      const res = await SpaceMessageCenterApi.listConversations(this.spaceId);
      if (typeof res === "string") {
        return;
      }
      const list = Array.isArray(res.list) ? res.list : [];
      const total = Math.max(0, Math.min(99, Number(res.totalUnreadCount) || 0));
      this.onUpdate(list, total);
    } finally {
      this.polling = false;
    }
  }

  /** 下拉刷新：等进行中的请求结束后再立即拉一次 */
  async refreshNow(): Promise<void> {
    while (this.polling) {
      await new Promise((r) => setTimeout(r, 30));
    }
    await this.syncOnce();
  }
}
